import React from "react";
import styles from "./layout-a.module.scss";
import classnames from "classnames";

const LayoutA = ({ children, className }) => {
  return <div className={classnames(styles.container, className)}>{children}</div>;
};

export default LayoutA;
